import React from 'react'
import CommonInput from '../common/CommonInput'

const ReceipeList = ({
  receipe = [],
  onChange,
  onClcik,
  readOnly,
  isClose,
}) => {
  const receipeList = receipe.map((_receipe, index) => {
    return (
      <CommonInput
        key={_receipe.id}
        style={{
          marginBottom: index === receipe.length - 1 ? '40px' : '20px',
        }}
        order={index + 1}
        defaultValue={_receipe.defaultValue}
        name={_receipe.id}
        onClick={onClcik}
        onChange={onChange}
        isClose={isClose}
        readOnly={readOnly}
      />
    )
  })

  return <div>{receipeList}</div>
}

export default ReceipeList
